/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2023-2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { createReducer } from '@reduxjs/toolkit';
import { CompanyAction } from './CompanyDataActions';
import { Company, User } from 'Api/generated';
import { StoreType } from 'index';

export interface ICompaniesState {
  Querying: boolean;
  Companies: Company[];
}

const initialState: ICompaniesState = {
  Querying: false,
  Companies: [],
};

const CompanysReducer = createReducer<ICompaniesState>(initialState, (builder) => {
  builder
    .addCase(CompanyAction.Query, (state) => {
      return {
        ...state,
        Querying: true,
      };
    })

    .addCase(CompanyAction.Queried, (state: ICompaniesState, action) => {
      return {
        ...state,
        Querying: false,
        Companies: action.payload,
      };
    })

    .addCase(CompanyAction.Created, (state: ICompaniesState, action) => {
      state = {
        ...state,
        Companies: [...state.Companies, action.payload],
      };
      return state;
    })

    .addCase(CompanyAction.Deleted, (state: ICompaniesState, action) => {
      state = {
        ...state,
        Companies: state.Companies.filter((c) => c.Id != action.payload),
      };
      return state;
    });
});

export default CompanysReducer;

export function getFilteredCompanies(store: StoreType, user: User): Company[] {
  const ret = store.companies.Companies.filter((comp) => comp.Users?.includes(user));
  return ret;
}
